<template>
  <div class="issues-list-container">
    <PreLoaderSection
      :options="{ height: '500', enabledTwoColumns: true }"
      v-if="issuesListLoading" />
    <Section v-if="!issuesListLoading">
      <div class="section-header" slot="header">
        <h1 class="title">Issue List</h1>
      </div>
      <div class="section-body">
        <IssuesListCollection :issuesList="sortedList" />
      </div>
    </Section>
  </div>
</template>

<script>
import _ from 'lodash';
import PreLoaderSection from '@/components/PreLoaderSection.vue';
import Section from '@/components/Section.vue';
import IssuesListCollection from '@/issues/IssuesListCollection.vue';

export default {
  props: ['issuesList', 'error', 'issuesListLoading'],
  components: {
    Section,
    PreLoaderSection,
    IssuesListCollection,
  },
  computed: {
    sortedList() {
      return _.sortBy(this.issuesList.errors, 'errorCategoryId');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
</style>
